(function () {
  function normalizeFilterButtonCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.collection-toolbar__button[aria-controls="facets-drawer"]').forEach(function (button) {
      var hasFilterText = false;

      Array.prototype.forEach.call(button.childNodes, function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;

        var text = node.textContent || '';
        if (!/\bFilter\b/.test(text) || /\bFilter By\b/.test(text)) return;

        node.textContent = text.replace('Filter', 'Filter By');
        hasFilterText = true;
      });

      if (!hasFilterText && button.textContent.trim() === 'Filter') {
        button.textContent = 'Filter By';
      }
    });
  }

  function normalizeSearchFilterButtonVisibility(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.main-search .collection-toolbar__button[aria-controls="facets-drawer"], .collection-toolbar__button[aria-controls="facets-drawer"]').forEach(function (button) {
      if (!button.closest('.main-search')) return;

      var container = button.closest('.collection-toolbar__button-container');
      if (!container) return;

      container.classList.remove('md:hidden');
    });
  }

  function install() {
    normalizeFilterButtonCopy(document);
    normalizeSearchFilterButtonVisibility(document);

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeFilterButtonCopy(node);
            normalizeSearchFilterButtonVisibility(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
})();
